/* Texture settings for the wall visualiser.
   sample  - which tile photograph the antiquing comes from
   box     - the clean interior of that photo as fractions (x0,y0 top-left, x1,y1 bottom-right);
             keep clear of the bevelled edge and any packaging
   window  - size of the patch each tile samples; smaller = more variety tile to tile
   warm    - multiply wash over the finished wall; warmer and deeper than the raw photo */
window.RETRO_TEX = {
  sample: '/cdn/shop/products/sample-antique-mirror-tile-free-delivery-413899.jpg?v=1771959170&width=1400',
  box:    { x0:0.15, y0:0.33, x1:0.63, y1:0.83 },
  window: 0.26,
  warm:   'rgba(206,188,163,.42)'
};